import { useTranslation } from 'react-i18next';

import { Button } from '@any-ui-react/core';

import { PlusIcon } from '@anyx/shared-icons';

import { RuleCombinator } from '../../types';

interface ConditionBuilderButtonsProps {
  combinator: RuleCombinator;
  addRule: (rule: RuleCombinator) => void;
  compact?: boolean;
  ruleCount?: number;
  disabled?: boolean;
}

export const ConditionBuilderButtons = ({
  compact,
  combinator,
  ruleCount = 1,
  addRule,
  disabled = false,
}: ConditionBuilderButtonsProps) => {
  if (compact) {
    return (
      <AddRuleButton
        compact
        type={combinator}
        onClick={() => addRule(combinator)}
        disabled={disabled}
      />
    );
  }

  return (
    <div className="text-gray-7 flex items-center gap-x-2 font-semibold">
      {combinator && ruleCount > 1 ? (
        <AddRuleButton type={combinator} onClick={() => addRule(combinator)} disabled={disabled} />
      ) : (
        <>
          <AddRuleButton
            type={RuleCombinator.AND}
            onClick={() => addRule(RuleCombinator.AND)}
            disabled={disabled}
          />
          <AddRuleButton
            type={RuleCombinator.OR}
            onClick={() => addRule(RuleCombinator.OR)}
            disabled={disabled}
          />
        </>
      )}
    </div>
  );
};

const AddRuleButton = ({
  type,
  onClick,
  compact,
  disabled,
}: {
  type: RuleCombinator;
  onClick: () => void;
  compact?: boolean;
  disabled?: boolean;
}) => {
  const { t } = useTranslation('crm');

  return (
    <Button
      variant="default"
      leftSection={<PlusIcon className="h-3 w-3" />}
      onClick={onClick}
      disabled={disabled}
    >
      {compact
        ? t('crm.conditionBuilder.addSegment')
        : t('crm.conditionBuilder.combinator', { type })}
    </Button>
  );
};
